<div class="popup">
  <div class="popup-content">
    <p>Your session is about to expire in {{ formattedCountdown }}. Do you want to stay logged in?</p>
    <div class="modal-buttons-container">
      <button class="btn" (click)="onExtendSession()">Yes</button>
      <button class="btn" (click)="onDismissPopup()">No</button>
    </div>
  </div>
</div>
